import React, { useState } from "react";
import { useLocation } from "react-router";
import { Link, NavLink } from "react-router-dom";
import {
  Box,
  Drawer,
  useMediaQuery,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  Button,
  Avatar,
  MenuItem,
  Typography,
  Divider,
} from "@mui/material";
import { SidebarWidth } from "../../../assets/global/Theme-variable";
import { ACCOUNTS_OPTIONS, LINKS } from "./data";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectCurrentagency } from "../../../redux/features/authSlice";
import { AGENCY_LOGOS_URL } from "../../../constants/url";
import {
  COONECT_FB,
  PROFILE_ROUTE,
  ROLES_ROUTE,
  XML_FEED,
} from "../../../constants/routes";
import { LogoutOutlined } from "@mui/icons-material";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import { GrUserSettings } from "react-icons/gr";
import { BsBell } from "react-icons/bs";
import Notification from "../../../components/Notification";
import useNotification from "../../../hooks/useNotification";
import { FaFacebookF } from "react-icons/fa";

const Sidebar = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const currentAgency = useSelector(selectCurrentagency);
  const { pathname } = useLocation();
  const pathDirect = pathname;
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const { agencyId } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleClick = (index) => {
    if (open === index) {
      setOpen((prevopen) => !prevopen);
    } else {
      setOpen(index);
    }
  };

  const handleUserMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logout());
    window.location.href = "https://realtorscrm.com";
  };

  const notification = useNotification(agencyId, 1);

  const SidebarContent = (
    <Box
      sx={{
        p: 3,
        height: "calc(100vh - 40px)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Link to="/">
        <Box
          sx={{
            display: "flex",
            alignItems: "Center",
            height: "80px",
            borderRadius: "10px",
            overflow: "hidden",
          }}
        >
          <img
            src="/static/images/logo.png"
            alt="logo"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Box>
      </Link>

      <Box>
        <List sx={{ mt: 4 }}>
          {LINKS.map((item) => (
            <ListItem
              key={item.title}
              button
              component={NavLink}
              to={item.href}
              sx={{
                mb: 1,
                borderRadius: 1,
                "&.active": {
                  color: "white",
                  bgcolor: (theme) => theme.palette.primary.main,
                  "& .MuiListItemIcon-root": {
                    color: "white",
                  },
                },
              }}
            >
              <ListItemIcon>
                <item.icon width="20" height="20" />
              </ListItemIcon>
              <ListItemText primary={item.title} />
            </ListItem>
          ))}
        </List>
      </Box>

      <Button onClick={handleUserMenuOpen} sx={{ mt: "auto" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Avatar
            alt={"Agency Logo"}
            src={AGENCY_LOGOS_URL + currentAgency.agencylogo}
            variant="rounded"
            sx={{
              width: "40px",
              height: "40px",
            }}
          />
          &nbsp;&nbsp;{currentAgency.agencyname}
        </Box>
      </Button>
      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleUserMenuClose}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        transformOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          component={Link}
          to={PROFILE_ROUTE}
          onClick={handleUserMenuClose}
        >
          <Avatar
            src={AGENCY_LOGOS_URL + currentAgency.agencylogo}
            sx={{
              width: "35px",
              height: "35px",
            }}
          />
          <Typography
            sx={{
              ml: 2,
            }}
          >
            Profile
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutOutlined fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open={true}
        variant="persistent"
        PaperProps={{
          sx: {
            width: SidebarWidth,
          },
        }}
      >
        {SidebarContent}
      </Drawer>
    );
  }
  return (
    <Drawer
      anchor="left"
      open={props.isMobileSidebarOpen}
      onClose={props.onSidebarClose}
      PaperProps={{
        sx: {
          width: SidebarWidth,
        },
      }}
      variant="temporary"
    >
      {SidebarContent}
    </Drawer>
  );
};

export default Sidebar;
